/* ==========================================================================
   EZINK header cart count
   --------------------------------------------------------------------------
   Replaces the previous UpCart-coupled module. The old one called
   window.upcartOpenCart() on click and exposed window.upcartModifyCart to
   set the bubble — so disabling UpCart left the header cart icon dead.

   It also only ever set innerHTML and never touched the hidden/flex classes
   that snippets/cart-count.liquid renders, so a cart going 0 -> 1 updated
   the number while the bubble stayed invisible. This version syncs both.
   ========================================================================== */

(function () {
  'use strict';

  function syncBubble(count) {
    var el = document.getElementById('CartCount');
    if (!el) return;
    el.innerHTML = count;
    el.classList.toggle('hidden', count === 0);
    el.classList.toggle('flex', count > 0);
  }

  if (!window.customElements.get('cart-count')) {
    window.customElements.define(
      'cart-count',
      class CartCount extends HTMLElement {
        constructor() {
          super();
          this.countEl = this.querySelector('#CartCount');
        }

        connectedCallback() {
          /* Open the drawer rather than navigating to /cart. The drawer's own
             capture-phase click handler also covers this element, so this is
             a belt-and-braces path for when the drawer script has not
             finished loading — in that case we let the link navigate. */
          this.addEventListener('click', function (e) {
            if (e.metaKey || e.ctrlKey || e.shiftKey || e.which === 2) return;
            if (window.EZCart && window.EZCart.built) {
              e.preventDefault();
              window.EZCart.open();
            }
          });
        }
      }
    );
  }

  document.addEventListener('ez:cart:updated', function (e) {
    if (e.detail) syncBubble(e.detail.item_count || 0);
  });

  /* Back-compat: anything still calling the old globals keeps working. */
  window.upcartModifyCart = function (cart) {
    if (cart) syncBubble(cart.item_count || 0);
  };
  window.upcartOpenCart = function () {
    if (window.EZCart) window.EZCart.open();
  };
})();
